var map = {
	"./2dgi.png": 385,
	"./blue-marker.png": 176,
	"./default.jpg": 132,
	"./dgi.png": 173,
	"./escudo.png": 174,
	"./green-marker.png": 177,
	"./logo.png": 175,
	"./marker.png": 166,
	"./red-marker.png": 178,
	"./thumbnail-default.jpg": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 220;